import React from 'react';
import Card from './Card';
import NewsletterCard from './NewsletterCard';

const BentoGrid = ({ resources }) => {
  const getVariant = (index) => {
    // Hand-tuned to keep a bento feel (without grid-row coupling).
    if (index === 0) return 'hero';
    if (index === 2) return 'tall';
    if (index === 4) return 'wide';
    if (index === 6) return 'tall';
    if (index === 7) return 'wide';
    return 'small';
  };

  const colsDesktop = [[], [], [], []];
  const desktopColumnForIndex = (index) => {
    // Stable columns: expanding a card only pushes cards below it in the same column.
    if (index === 0) return 0;
    if (index === 1) return 1;
    if (index === 2) return 2;
    if (index === 3) return 3;
    if (index === 4) return 1;
    if (index === 5) return 2;
    if (index === 6) return 0;
    if (index === 7) return 3;
    return 3;
  };

  resources.forEach((resource, index) => {
    colsDesktop[desktopColumnForIndex(index)].push({ resource, index });
  });

  return (
    <div className="relative">
      <div className="mb-3 md:mb-4">
        <NewsletterCard spanClass="opacity-0 animate-fade-in-up stagger-1 w-full" />
      </div>

      {/* Mobile: preserve natural reading order */}
      <div className="flex flex-col gap-3 md:hidden">
        {resources.map((resource, index) => (
          <Card
            key={index}
            title={resource['Ressource name']}
            type={resource['Type']}
            description={resource["Why it's useful"]}
            link={resource['Link']}
            image={resource['Image']}
            variant={getVariant(index)}
            index={index + 1}
          />
        ))}
      </div>

      {/* Desktop: independent columns so only hovered card pushes below */}
      <div className="hidden md:grid md:grid-cols-4 gap-3 md:gap-4 items-start">
        {colsDesktop.map((col, colIndex) => (
          <div key={colIndex} className="flex flex-col gap-3 md:gap-4">
            {col.map(({ resource, index }) => (
              <Card
                key={index}
                title={resource['Ressource name']}
                type={resource['Type']}
                description={resource["Why it's useful"]}
                link={resource['Link']}
                image={resource['Image']}
                variant={getVariant(index)}
                index={index + 1}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BentoGrid;
